import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticStyle:{"height":"95vh !important"},attrs:{"fluid":""}},[(_vm.loading)?_c('lottie',{attrs:{"options":_vm.lottieOptions,"height":250,"width":250}}):_c(VRow,{staticStyle:{"height":"100%"},attrs:{"align":"center","justify":"center"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }